// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "closeClassName-2BHhx";
var _5 = "dialog__content_padding-3w6Oo";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "closeClassName", _5 as "dialog__content_padding" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "closeClassName": _4, "dialog__content_padding": _5 }
